// extracted by mini-css-extract-plugin
export default {"price":"xba-z","onSale":"yba-z","msrpLabelPrice":"zba-z","msrpLabel":"Aba-z","originalPrice":"Bba-z"};